export default __webpack_public_path__ + "static/media/team-2.b2008acd.jpg";